import Grid from '@mui/material/Grid';
import Title from '../Shared/Title';
import Match from "../Match/Match";

const RowSchema = props => {
    return (
        <Grid container className="ContainerRow">
            <Grid item xs={3}>
                <Title
                    row
                    href={`/schemas/${props.item.Id}`}
                    systems={props.systems}
                    label={props.item.Name}
                />
            </Grid>
            <Grid item xs={3}>
                <Match type="executions" matches={props.matches.executions} handler={() => props.getExecutions(props.matches.jobs.map(x => x.Id))} />
            </Grid>
            <Grid item xs={3}>
                <Match type="queries" matches={props.matches.queries} />
            </Grid>
            <Grid item xs={3}>
                <Match type="jobs" matches={props.matches.jobs} />
            </Grid>

        </Grid>
    )
}

export default RowSchema